import { renderProfile } from "./chart.js";
import { ElevationService } from "./ElevationService.js";
import { GPXExporter } from "./GPXExporter.js";
import { createMap } from "./map.js";
import { ORSRoutingService } from "./ORSRoutingService.js";
import { RouteEditor } from "./RouteEditor.js";
import { debounce } from "./utils.js";

export function bootInstance(root) {
  const mapEl = root.querySelector(".bhgpxrp__map");
  const mapContainer = root.querySelector(".bhgpxrp__mapContainer");
  const height = root.dataset.height || "600px";

  mapEl.style.height = height;
  mapContainer.style.height = height;

  try {
    const map = createMap(mapEl, {
      thunderforestUrl: root.dataset.thunderforestUrl,
    });
    const routingService = new ORSRoutingService(root.dataset.routeUrl, root.dataset.routeNonce);
    const elevationService = new ElevationService();
    const gpxExporter = new GPXExporter();
    const editor = new RouteEditor({
      root,
      map,
      routingService,
      elevationService,
      gpxExporter,
      renderProfile,
    });

    editor.boot();
    window.addEventListener("resize", debounce(() => editor.renderElevationProfile(), 150));
  } catch (error) {
    const status = root.querySelector(".bhgpxrp__status");
    status.textContent = error.message || "Unable to initialize the route planner.";
    status.classList.add("bhgpxrp__status--error");
    console.error(error);
  }
}
